var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mocks",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.947,
    height: 95.906,
    viewBox: "0 0 95.947 95.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae3bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6415fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    "data-name": "Caminho 364",
    d: "M0,53.939a5.675,5.675,0,0,0,.5-.4q10.235-10.226,20.462-20.46c.11-.11.211-.228.367-.4-.228-.247-.445-.495-.676-.725Q11.883,23.184,3.11,14.41c-3.342-3.344-3.319-7.447,0-10.82A8.549,8.549,0,0,1,7.723.742a7.128,7.128,0,0,1,6.551,2.183q8.8,8.816,17.609,17.619c.242.242.445.523.641.756Q43.291,10.536,53.824,0C67.88,14.058,81.8,27.976,95.947,42.125a4.591,4.591,0,0,0-.87.579Q68.844,68.914,42.629,95.144c-.238.238-.442.506-.662.761H41.78a6.428,6.428,0,0,0-.413-.493Q20.932,74.971.493,54.536c-.15-.15-.329-.276-.493-.411ZM41.872,91.454,91.437,41.891Q72.748,23.2,54.043,4.484L34.818,23.711a5.328,5.328,0,0,1,.79.563q4.351,4.325,8.671,8.683a2.327,2.327,0,0,1,.63,1.188c.478,3.081.906,6.172,1.342,9.261.15,1.062.278,2.126.426,3.27-4.383-.624-8.612-1.216-12.836-1.85a1.917,1.917,0,0,1-.9-.6q-4.354-4.325-8.683-8.671c-.234-.234-.48-.455-.592-.561Q14.018,44.64,4.545,54.117L41.876,91.454Zm-.615-57.389a9.07,9.07,0,0,1-.809-.649c-9.178-9.139-18.4-18.231-27.491-27.46-2.6-2.644-5.16-3.036-7.9.084-1.677,1.911-1.78,4.09,0,5.91q3.009,3.08,6.043,6.134Q22.316,29.314,33.547,40.53c.213.213.438.411.611.573l2.48-2.389q-11.9-11.893-23.705-23.7l2.145-2.261Q27,24.682,38.79,36.472l2.469-2.406Zm-3.723,8.22,5.573.792c-.278-1.9-.537-3.683-.824-5.651-1.584,1.593-3.011,3.026-4.437,4.461-.084.084-.148.187-.314.4Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    "data-name": "Caminho 365",
    d: "M182.154,388.328c1.245,1.252,2.577,2.6,3.917,3.942,1.108,1.108,1.816,1.108,2.925,0q3.808-3.8,7.6-7.611a5.562,5.562,0,0,0,.571-.818l2.24,2.28c-.091.1-.259.316-.449.5q-3.934,3.94-7.872,7.87c-2.253,2.242-4.88,2.223-7.149-.034-1.346-1.34-2.691-2.678-4.02-4l2.231-2.134Z",
    transform: "translate(-145.676 -310.785)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    "data-name": "Caminho 366",
    d: "M125.945,240.094Q118.468,232.617,110.85,225l1.977-1.911q7.514,7.514,15.121,15.123Z",
    transform: "translate(-89.752 -180.63)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_367",
    "data-name": "Caminho 367",
    d: "M86.43,249.261c.662-.657,1.325-1.311,1.888-1.871l15.194,15.194-1.879,1.869Z",
    transform: "translate(-69.98 -200.305)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_368",
    "data-name": "Caminho 368",
    d: "M79.993,286.383l-1.985,1.911L62.93,273.217l1.941-1.957q7.5,7.5,15.121,15.121Z",
    transform: "translate(-50.953 -219.632)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_369",
    "data-name": "Caminho 369",
    d: "M283.96,65.574c-.563.539-1.256,1.2-1.869,1.785q-5.245-5.244-10.571-10.575l1.858-1.795Z",
    transform: "translate(-219.843 -44.524)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_370",
    "data-name": "Caminho 370",
    d: "M259.9,89.235c-.641.605-1.317,1.247-1.907,1.8l-10.6-10.6,1.858-1.85c3.531,3.529,7.054,7.05,10.649,10.645Z",
    transform: "translate(-200.305 -63.632)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_371",
    "data-name": "Caminho 371",
    d: "M223.222,104.423l1.934-2.1q5.339,5.342,10.6,10.6l-1.989,2.036q-5.322-5.319-10.546-10.536Z",
    transform: "translate(-180.735 -82.846)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_372",
    "data-name": "Caminho 372",
    d: "M342.221,159.16l.019-.019q1-1,2-1.995l-.03-.029q-4.274-4.274-8.576-8.578h0l-.006-.006-2.014-2.014-.08.088,0,0-8.519,8.525,0,0-.086.093q-.962.965-1.928,1.93c.027.027.053.053.08.078h0l8.53,8.523,0,0,.318.31c.567.565,1.132,1.132,1.7,1.7l.1-.1q4.24-4.24,8.509-8.508h0Zm-8.608,4.579-6.591-6.593q3.283-3.283,6.589-6.587l6.591,6.585Z",
    transform: "translate(-261.516 -118.633)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_373",
    "data-name": "Caminho 373",
    d: "M267.621,232.62l.019-.019q1-1,2-1.995l-.03-.029Q265.332,226.3,261.03,222h0l-.006-.006-2.014-2.014-.08.088,0,0-8.519,8.525,0,0-.086.093q-.962.965-1.928,1.93c.027.027.053.053.08.078h0l8.53,8.523,0,0,.318.31c.567.565,1.132,1.132,1.7,1.7l.1-.1q4.24-4.24,8.51-8.508h0Zm-8.608,4.579-6.591-6.593q3.283-3.283,6.589-6.587L265.6,230.6Z",
    transform: "translate(-201.115 -178.112)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_374",
    "data-name": "Caminho 374",
    d: "M189.731,311.66l.019-.019q1-1,2-1.995l-.03-.029q-4.274-4.274-8.576-8.578h0l-.006-.006-2.014-2.014-.08.088,0,0-8.519,8.525,0,0-.086.093q-.962.965-1.928,1.93c.027.027.053.053.08.078h0l8.53,8.523,0,0,.318.31c.567.565,1.132,1.132,1.7,1.7l.1-.1q4.24-4.24,8.51-8.508h0Zm-8.608,4.579-6.591-6.593q3.283-3.283,6.589-6.587l6.591,6.585Z",
    transform: "translate(-138.049 -242.109)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_375",
    "data-name": "Caminho 375",
    d: "M281.75,362.433c.961-.965,1.926-1.932,2.836-2.843l2.035,2.029-2.922,2.805-1.947-1.991Z",
    transform: "translate(-228.126 -291.151)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMocks);
export default __webpack_public_path__ + "static/media/mocks.f15fe8c5d46e2e698a765e6ee8a9507c.svg";
export { ForwardRef as ReactComponent };